import { createUseStyles } from "react-jss";
import { colour } from "../../../constants/Colours";

export const useStyles = createUseStyles({
  hightLightedRow: {
    boxShadow: "0 0 0px 1.5px" + colour.blue7,
  },
});
